import React, { useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/about.css';

const NptBreak = () => {
  const underlineRef = useRef(null);
  useEffect(() => {
    const t = setTimeout(() => underlineRef.current && underlineRef.current.classList.add('animate'), 50);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <div 
        className="container-fluid d-flex align-items-center" 
        style={{ 
          minHeight: '100vh', 
          padding: 0, 
          top: '-122px', 
          position: 'relative', 
          backgroundImage: "url('/assets/npt2.jpg')", 
          backgroundSize: 'cover', 
          backgroundPosition: 'center', 
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed'
        }}
      >
        {/* Dark Overlay for better text readability */}
        <div 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(12, 97, 192, 0.5) 50%, rgba(0, 0, 0, 0.8) 100%)',
            zIndex: 1
          }}
        />
        
        {/* Animated Background Elements */}
        <div 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: `
              radial-gradient(circle at 20% 80%, rgba(12, 97, 192, 0.3) 0%, transparent 50%),
              radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 40% 40%, rgba(12, 97, 192, 0.2) 0%, transparent 50%)
            `,
            zIndex: 2
          }}
        />

        <div className="container about-content py-5" style={{ position: 'relative', zIndex: 3 }}>
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h1 
                className="display-3 fw-bold mb-4" 
                style={{ 
                  color: '#fff', 
                  textShadow: '2px 2px 8px rgba(0,0,0,0.8)',
                  background: 'linear-gradient(45deg, #fff, #e6f0ff)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}
              >
                NPT Break
              </h1>
              <h2 
                className="h3 mb-4" 
                style={{ 
                  color: '#cfe6ff', 
                  textShadow: '1px 1px 4px rgba(0,0,0,0.6)',
                  fontWeight: '300'
                }}
              >
                Mastering NPT Reduction
              </h2>
              <div 
                className="mx-auto mb-5" 
                style={{ 
                  width: '100px', 
                  height: '4px', 
                  background: 'linear-gradient(90deg, #0c61c0, #42a5f5)', 
                  borderRadius: '2px',
                  boxShadow: '0 2px 8px rgba(12, 97, 192, 0.5)'
                }}
                ref={underlineRef}
              ></div>
              
              {/* Feature Cards */}
              <div className="row g-4 mt-5">
                <div className="col-md-4">
                  <div 
                    className="card h-100 border-0" 
                    style={{ 
                      background: 'rgba(255, 255, 255, 0.1)', 
                      backdropFilter: 'blur(10px)',
                      borderRadius: '15px',
                      border: '1px solid rgba(255, 255, 255, 0.2)'
                    }}
                  >
                    <div className="card-body text-center p-4">
                      <div 
                        className="mx-auto mb-3" 
                        style={{ 
                          width: '60px', 
                          height: '60px', 
                          background: 'linear-gradient(45deg, #0c61c0, #42a5f5)', 
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <i className="bi bi-graph-up text-white" style={{ fontSize: '24px' }}></i>
                      </div>
                      <h5 className="text-white mb-3">Performance Analytics</h5>
                      <p className="text-light mb-0">Advanced analytics to optimize drilling operations and reduce NPT</p>
                    </div>
                  </div>
                </div>
                
                <div className="col-md-4">
                  <div 
                    className="card h-100 border-0" 
                    style={{ 
                      background: 'rgba(255, 255, 255, 0.1)', 
                      backdropFilter: 'blur(10px)',
                      borderRadius: '15px',
                      border: '1px solid rgba(255, 255, 255, 0.2)'
                    }}
                  >
                    <div className="card-body text-center p-4">
                      <div 
                        className="mx-auto mb-3" 
                        style={{ 
                          width: '60px', 
                          height: '60px', 
                          background: 'linear-gradient(45deg, #0c61c0, #42a5f5)', 
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <i className="bi bi-people text-white" style={{ fontSize: '24px' }}></i>
                      </div>
                      <h5 className="text-white mb-3">Team Collaboration</h5>
                      <p className="text-light mb-0">Streamlined workflows for faster problem resolution</p>
                    </div>
                  </div>
                </div>
                
                <div className="col-md-4">
                  <div 
                    className="card h-100 border-0" 
                    style={{ 
                      background: 'rgba(255, 255, 255, 0.1)', 
                      backdropFilter: 'blur(10px)',
                      borderRadius: '15px',
                      border: '1px solid rgba(255, 255, 255, 0.2)'
                    }}
                  >
                    <div className="card-body text-center p-4">
                      <div 
                        className="mx-auto mb-3" 
                        style={{ 
                          width: '60px', 
                          height: '60px', 
                          background: 'linear-gradient(45deg, #0c61c0, #42a5f5)', 
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <i className="bi bi-gear text-white" style={{ fontSize: '24px' }}></i>
                      </div>
                      <h5 className="text-white mb-3">Smart Automation</h5>
                      <p className="text-light mb-0">AI-powered tools for continuous improvement</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="py-5 bg-white">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="card shadow-sm border-0 mb-4">
                <div className="card-body p-4 p-md-5">
                  <div className="row g-4 align-items-center">
                    <div className="col-md-8">
                      <p className="mb-3">NPT Break transforms operational performance by minimizing downtime, enhancing productivity, and empowering teams with advanced learning tools and streamlined workflows to achieve optimal drilling efficiency and improved well deliverability.</p>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item px-0"><i className="bi bi-graph-up-arrow text-success me-2"></i>Issue management and continuous performance improvement</li>
                        <li className="list-group-item px-0"><i className="bi bi-clipboard-check text-primary me-2"></i>Collaborative tools for faster problem resolution</li>
                        <li className="list-group-item px-0"><i className="bi bi-clock-history text-warning me-2"></i>Reduce NPT and streamline reporting workflows</li>
                        <li className="list-group-item px-0"><i className="bi bi-cpu text-info me-2"></i>Analytics to optimize resources with maximum efficiency</li>
                      </ul>
                    </div>
                    <div className="col-md-4">
                      <div className="card border-0 shadow-sm h-100">
                        <div className="ratio ratio-4x3 d-md-block d-none" style={{ backgroundColor: '#fff' }}>
                          <img src="/assets/npt-break.jpg" alt="NPT Break" className="img-fluid" style={{ objectFit: 'cover' }} onError={(e)=>{e.currentTarget.src='/assets/Banner4.webp';}} />
                        </div>
                        <img src="/assets/npt-break.jpg" alt="NPT Break" className="img-fluid d-md-none" style={{ objectFit: 'cover' }} onError={(e)=>{e.currentTarget.src='/assets/Banner4.webp';}} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row g-4">
                <div className="col-md-4">
                  <div className="card h-100 shadow-sm border-0">
                    <div className="card-body">
                      <h5><i className="bi bi-phone-vibrate me-2 text-primary"></i>Responsive</h5>
                      <p className="mb-0">Modern, responsive interfaces that keep teams aligned in the field and office.</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card h-100 shadow-sm border-0">
                    <div className="card-body">
                      <h5><i className="bi bi-stars me-2 text-warning"></i>Constant updates</h5>
                      <p className="mb-0">Continuously improved modules that reflect new industry practices.</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card h-100 shadow-sm border-0">
                    <div className="card-body">
                      <h5><i className="bi bi-chat-left-dots me-2 text-success"></i>5‑star support</h5>
                      <p className="mb-0">Implementation assistance and training to ensure rapid adoption.</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card shadow-sm border-0 mt-4">
                <div className="card-body p-4">
                  <h5 className="mb-2">Trusted by teams</h5>
                  <p className="mb-0">Built to help operators and service companies reduce NPT and enhance quality across drilling operations.</p>
                </div>
              </div>

              {/* CTA Section */}
              <div className="card border-0 shadow-lg mt-5" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                <div className="card-body p-5 text-center" style={{ background: 'linear-gradient(135deg, #0c61c0 0%, #084b9a 100%)' }}>
                  <div className="bg-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px' }}>
                    <i className="bi bi-rocket-takeoff text-primary" style={{ fontSize: '2rem' }}></i>
                  </div>
                  <h3 className="text-white fw-bold mb-3" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    Ready to Transform Your Drilling Operations?
                  </h3>
                  <p className="text-white mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.7', opacity: '0.9' }}>
                    Join the growing number of operators that trust NPT Break for their drilling efficiency and NPT reduction needs.
                  </p>
                  <div className="d-flex justify-content-center gap-3 flex-wrap">
                    <button 
                      className="btn btn-light btn-lg px-4 py-3 fw-bold" 
                      style={{ borderRadius: '8px' }}
                      onClick={() => window.open('https://petrochoice.ae/', '_blank')}
                    >
                      Get Started Now
                    </button>
                    <button 
                      className="btn btn-outline-light btn-lg px-4 py-3 fw-bold" 
                      style={{ borderRadius: '8px' }}
                      onClick={() => window.open('https://petrochoice.ae/', '_blank')}
                    >
                      Request a Demo
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NptBreak;


